export default __webpack_public_path__ + "static/media/cross-symbol-icon-button-png.868f61a1.webp";